import { useState, useEffect } from 'react';
import '../../../entrydoor.css';

const ALL_OPTIONS = [
  { value: 'Laminated',  label: 'Laminated'  },
  { value: 'Composite',  label: 'Composite'  },
];

// Jambs options 2 and 4 (1-indexed) only allow Laminated
const LAMINATED_ONLY_JAMBS = ['5 1/2" x 1 1/4"', '8 1/4" x 1 1/4"'];

const JambMaterial = ({ value = { value: '', label: '' }, onChange, disabled = false, jambs }) => {
  const [selected,     setSelected]     = useState(value?.value || '');
  const [showWarning,  setShowWarning]  = useState(false);

  const options = LAMINATED_ONLY_JAMBS.includes(jambs?.value)
    ? ALL_OPTIONS.filter(o => o.value === 'Laminated')
    : ALL_OPTIONS;

  // If restricted to Laminated and current selection is Composite, auto-correct
  useEffect(() => {
    if (LAMINATED_ONLY_JAMBS.includes(jambs?.value) && selected === 'Composite') {
      setSelected('Laminated');
      setShowWarning(false);
      onChange({ value: 'Laminated', label: 'Laminated' });
    }
  }, [jambs?.value]);

  useEffect(() => { setSelected(value?.value || ''); }, [value?.value]);

  const handleChange = (e) => {
    const v = e.target.value;
    const label = ALL_OPTIONS.find(o => o.value === v)?.label || v;
    setSelected(v);
    setShowWarning(v === 'Composite');
    onChange({ value: v, label });
  };

  return (
    <div className="a-container">
      <label htmlFor="SdJambMaterial">Jamb Material</label>
      <select id="SdJambMaterial" value={selected} onChange={handleChange} disabled={disabled}>
        {options.map(o => (
          <option key={o.value} value={o.value}>
            {selected === o.value ? `${o.label} ✔` : o.label}
          </option>
        ))}
      </select>
      {showWarning && (
        <div className="jamb-warning" style={{ display: 'block' }}>
          Please Note: Composite Jambs and Brickmould must be Painted/Stained Inside and Out
        </div>
      )}
    </div>
  );
};

export default JambMaterial;
